<div class="row center">
  <div class="col s12 l12 center-align">
    <img class="responsive-img" src="../../assets/404_background_missing_tree.png" alt="">
  </div>
</div>

<div class="row center">
  <div class="col s12 l12 center-align">
    <h2>
      {{ 'NotFound.Description' | translate:locale.language }}
    </h2>
  </div> 
</div>
